module.exports = __webpack_public_path__ + "img/logo-clinipam.cdf996f0.jpg";